const en = {
    "sc_title": "Security Center",
    "sc_subtitle": "GaiaShield Integrated Security Layer",
    "sc_tab_status": "🛡️ Protection Status",
    "sc_tab_events": "📋 Security Log",
    "sc_tab_node": "⚙️ Node Security",
    "sc_loading": "Loading security data...",
    "sc_status_secured": "System Status: Account is protected",
    "sc_status_warning": "System Status: Warnings active",
    "sc_desc_secured": "There are no active critical security warnings. GaiaShield is actively monitoring your account.",
    "sc_desc_warning": "Attention: There are active security events that require your attention.",
    "sc_account_protection": "Account Protection",
    "sc_message_protection": "Message Protection",
    "sc_audits": "Security Audits",
    "sc_active": "ACTIVE",
    "sc_failed_logins": "Failed Logins",
    "sc_tamper_checks": "Tamper Checks",
    "sc_blocked_replays": "Blocked Replays",
    "sc_last_check": "Last Check",
    "sc_just_now": "Just now",
    "sc_open_warnings": "Open Warnings",
    "sc_btn_acknowledge": "Acknowledge",
    "sc_filter_severity": "Severity",
    "sc_filter_category": "Category",
    "sc_filter_hide_ack": "Hide Confirmed",
    "sc_btn_export": "Export",
    "sc_col_details": "Details",
    "sc_col_time": "Time",
    "sc_col_status": "Status",
    "sc_col_action": "Action",
    "sc_no_events": "No security events found.",
    "sc_node_title": "Node Operator Security Console",
    "sc_system_health": "System Health",
    "sc_last_audit": "Last Audit",
    "sc_packed_logs": "Packed Logs",
    "sc_unconfirmed_events": "Unconfirmed Events",
    "sc_operator_action": "Operator Action Required",
    "sc_all_ok": "All OK",
    "sc_critical_events": "Critical System Events",
    "ac_title": "Governance & Abuse Center",
    "ac_subtitle": "GaiaCom Governance & Abuse Consensus",
    "ac_tab_my_reports": "My Reports",
    "ac_tab_queue": "Review Queue",
    "ac_tab_operator": "Node Operator",
    "ac_tab_transparency": "Federation & Transparency",
    "ac_loading": "Loading data...",
    "ac_reported_cases": "Reported Cases",
    "ac_no_reports": "You have not submitted any reports yet.",
    "ac_case_details": "Case Details",
    "ac_appeal_submit": "Submit Appeal",
    "ac_appeal_status": "Appeal Status",
    "ac_appeal_reason": "Reason for Appeal",
    "ac_appeal_statement": "Statement",
    "ac_btn_appeal": "Send Appeal",
    "ac_trusted_reviewer_queue": "Trusted Reviewer Queue",
    "ac_case_review": "Review Case",
    "ac_review_category": "Recommended Category",
    "ac_review_severity": "Recommended Severity",
    "ac_review_action": "Recommended Action",
    "ac_review_reason": "Reviewer Reason",
    "ac_btn_submit_review": "Submit Review",
    "ac_node_operator_dashboard": "Node Operator Dashboard",
    "ac_apply_action": "Apply Action (Override)",
    "ac_target_type": "Target Type",
    "ac_target_id": "Target ID (GaiaID or Channel ID)",
    "ac_suspend": "Suspend active",
    "ac_reason": "Official Reason",
    "ac_btn_apply": "Enforce Action",
    "ac_transparency_title": "Consensus & Transparency Logbook",
    "ac_transparency_desc": "Publicly viewable snapshot proofs of all moderated channels and identities.",
    "ac_btn_snapshot": "Create Transparency Snapshot",
    "search_placeholder": "Search mails by subject, sender, text...",
    "abuse_center_title": "Abuse Center",
    "abbrechen": "Cancel",
    "active_identities": "Active Identities",
    "active_identity": "Active Identity",
    "add_btn": "Add",
    "add_contact_title": "Add contact",
    "admin": "Admin",
    "adressbuch": "Address Book",
    "aktiviert": "Enabled",
    "an": "To",
    "anonymous_sender": "Anonymous Sender",
    "antworten": "Reply",
    "attachment_gaia_hint": "GaiaCOM attachments remain end-to-end encrypted.",
    "attachment_smtp_hint": "Legacy SMTP blocks executable/script-like attachments and saves emails as insecure.",
    "attachments": "Attachments",
    "auffaellig": "Conspicuous",
    "auth_beta_notice": "Beta test phase: GaiaCOM is actively being tested. Bugs may occur; keep important seeds backed up and verify sensitive workflows carefully.",
    "auth_btn_login": "Load Identity & Log In",
    "auth_btn_register": "Register & Create Keys",
    "auth_copied": "Copied",
    "auth_copy_seed": "Copy Seed",
    "auth_generate_seed": "Generate Seed",
    "auth_headline": "GaiaCOM is the first quantum-secure email protocol and communication system built for humanity.",
    "auth_kicker": "Post-Quantum Secure Communication",
    "auth_mnemonic": "Mnemonic Phrase",
    "auth_mnemonic_placeholder": "12 words separated by spaces...",
    "auth_password": "Password",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "Private keys never leave your device. Only intended recipients can decrypt content.",
    "auth_proof_gaiadata_desc": "Zero-knowledge: You keep control of your data. Metadata is minimized and not turned into a plaintext profile.",
    "auth_proof_gaiadrop_desc": "External people can submit confidential text-only reports to your GaiaID without an account.",
    "auth_proof_gaiaproof_desc": "Delivery and integrity proofs show that ciphertext, sender, and timestamp were not manipulated.",
    "auth_proof_gaiavault_desc": "Private notes, recovery hints, and security records remain locally encrypted.",
    "auth_proof_hybrid_desc": "Quantum Shield: Hybrid encryption with ML-KEM and X25519 protects against current attacks and store-now-decrypt-later risk.",
    "auth_secure_mail": "Secure Quantum Federated Mail",
    "auth_subline": "GaiaCOM is a quantum-secure communication system for mail, chat, crisis rooms, GaiaDrop, and local security records. Private keys stay on your device, content is end-to-end encrypted, and evidence can be exported without revealing plaintext.",
    "auth_success_btn": "Log In Now",
    "auth_success_text": "Your GaiaCOM account has been created. The keys were derived locally from your seed and not stored on the server.",
    "auth_success_title": "Registration Successful",
    "auth_tab_drop": "GaiaDrop",
    "auth_tab_login": "Login / Account",
    "auth_toggle_login": "Already have an account",
    "auth_toggle_register": "Create new account",
    "auth_usecase_text": "Designed for lawyers, companies, agencies, journalists, whistleblowers, and private security incidents.",
    "auth_usecase_title": "Built for sensitive communication",
    "auth_username": "Username",
    "auth_username_placeholder": "Enter username...",
    "auth_value_chat": "E2E Chat",
    "auth_value_drop": "Secure Drop",
    "auth_value_mail": "Secure Mail",
    "auth_value_rooms": "GaiaRooms",
    "bestaetigen": "Confirm",
    "bestaetigt": "Confirmed",
    "bio_status": "Biography / Status",
    "biography": "Biography",
    "change_password_desc": "Changes your server-side login password. Your local recovery phrase remains separate and protected by your Vault/Unlock password.",
    "change_password_menu_desc": "Update GaiaCOM login password.",
    "change_password_title": "Change Password",
    "channel_id": "Channel ID",
    "channel_name_label": "Channel name",
    "chat_deleted_hidden": "Chat deleted and hidden.",
    "chat_input_placeholder": "Enter secure message...",
    "chat_start_hint": "Start the conversation! All chat messages are quantum-secure E2E encrypted.",
    "choose_avatar": "Choose Avatar",
    "ciphertext_hash": "Ciphertext Hash",
    "clear_chat": "Empty chat",
    "clear_for_everyone": "Empty for everyone",
    "clear_for_me": "Empty just for me",
    "click_to_write_mail": "Click to write an email",
    "click_top_right": "Click on the top right",
    "close": "Close",
    "code_kopieren": "Copy Code",
    "code_kopieren_success": "Code copied",
    "confirm_clear_channel_desc": "Do you want to clear this channel from your local view?",
    "confirm_clear_channel_title": "Empty channel",
    "confirm_clear_chat": "Do you want to clear this chat?",
    "confirm_clear_chat_desc": "Do you want to empty this chat?",
    "confirm_clear_chat_title": "Empty chat",
    "confirm_clear_everyone": "Do you want to clear this chat for both partners? (OK = For everyone, Cancel = Only for me)",
    "confirm_delete_everyone": "Do you want to delete this message for both partners? (OK = For everyone, Cancel = Only for me)",
    "confirm_delete_msg": "Do you want to delete this message?",
    "confirm_delete_msg_desc": "Do you want to delete this chat message?",
    "confirm_delete_msg_title": "Delete message",
    "confirm_new_password": "Confirm New Password",
    "copy": "Copy",
    "create_btn": "Create",
    "create_channel_title": "Create channel",
    "create_group_is_crisis": "Mark as a crisis area",
    "create_group_title": "Create new group",
    "crypto_lock_desc": "Controls when GaiaCOM removes local crypto keys from memory.",
    "crypto_lock_menu_desc": "Control reload and inactivity timers.",
    "crypto_lock_title": "Cryptographic lock",
    "crypto_session_duration": "Unlocked after reload",
    "crypto_session_duration_desc": "Only keeps the crypto session open in this browser tab for the selected duration.",
    "cryptographic_fingerprint": "Cryptographic Fingerprint",
    "current_password": "Current Password",
    "data_minimization": "Data Minimization",
    "decrypt_failed": "Not decryptable",
    "delete": "Delete",
    "delete_account_button": "Delete account irrevocably",
    "delete_account_confirm_label": "Enter DELETE to confirm",
    "delete_account_confirmation_error": "Password and DELETE confirmation are required.",
    "delete_account_desc": "This mode permanently destroys your account, identities, device sessions, GaiaDrop data, upload metadata, and server-side attributable messages.",
    "delete_account_done_desc": "All assignable GaiaCOM data has been deleted.",
    "delete_account_done_title": "Account deleted",
    "delete_account_menu_desc": "Destroy account and associated data.",
    "delete_account_not_authenticated": "No active account.",
    "delete_account_title": "Delete account",
    "delete_for_everyone": "Delete for everyone",
    "delete_for_me": "Delete just for me",
    "device_current": "This device",
    "device_last_seen": "Last",
    "device_logout": "Log out",
    "device_sessions_desc": "Check active sessions and deregister devices you no longer trust.",
    "device_sessions_empty": "No devices found.",
    "device_sessions_menu_desc": "Manage and end active sessions.",
    "device_sessions_title": "Registered devices",
    "device_since": "Since",
    "display_name": "Display Name",
    "drop_address_copied": "GaiaDrop address copied.",
    "drop_btn_decrypting": "Decrypting inbox...",
    "drop_btn_load": "Load GaiaDrop Inbox",
    "drop_delete_desc": "Do you really want to permanently delete this drop?",
    "drop_delete_title": "Delete GaiaDrop",
    "drop_desc": "Text-only zero-knowledge drop channel for external hints, responsible disclosure, and confidential reports. External users can send messages using your GaiaID without an account.",
    "drop_empty": "No GaiaDrop messages loaded yet.",
    "drop_id": "Drop ID:",
    "drop_own_address": "Your GaiaDrop address",
    "drop_proof": "DROP PROOF",
    "drop_title": "GaiaDrop Secure Inbox",
    "dunkler_modus": " Dark Mode",
    "e2e_chat_room_open": "Open E2E Chat Room",
    "edit_profile": "Edit Profile",
    "edit_profile_desc": "Customize display name, bio and avatar.",
    "einladungscode": "Invite Code",
    "enter_fingerprint_chars_confirm": "Enter the requested fingerprint characters to confirm.",
    "envelope_hash": "Envelope Hash",
    "erasability": "Erasability",
    "erfolg": "Success",
    "exclude_plaintext": "Export without plain text",
    "export_disclosure": "Export Disclosure",
    "export_package_desc": "Only include plain text if this disclosure is intentionally intended.",
    "export_package_title": "Export security package",
    "fehler": "Error",
    "gaiacom_reader": "GaiaCOM Reader",
    "gaiadrop_inbox_title": "GaiaDrop Inbox",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM minimizes metadata, keeps private keys local, encrypts content end-to-end and enables complete account deletion.",
    "gdpr_home_title": "100% GDPR compliant",
    "gdpr_reason_delete": "Account deletion removes account, identities, local sessions, and server-side assignable data.",
    "gdpr_reason_e2ee": "Private content remains decryptable only for intended recipients.",
    "gdpr_reason_minimal": "Metadata is only used for routing, delivery and security credentials.",
    "gdpr_reason_zero_knowledge": "Private keys and recovery data remain locally under user control.",
    "gesendet": "Sent",
    "gesperrt_verdaechtig": "Blocked / Suspicious",
    "group_delete_desc": "Do you really want to permanently delete this group? All channels and messages in this group will be deleted.",
    "group_delete_title": "Delete group",
    "group_description": "Description",
    "group_icon_label": "Group icon / avatar",
    "group_name": "Group name",
    "group_settings_avatar": "Avatar",
    "group_settings_desc": "Description",
    "group_settings_is_crisis": "Mark as a crisis area",
    "group_settings_name": "Group Name",
    "group_settings_title": "Group Settings",
    "groups_empty_desc": "Create a secure workspace for project, crisis, or team communication.",
    "groups_empty_title": "No group chats yet",
    "gruppe_beitreten": "Group Joined",
    "gruppe_erstellen": "+ Create Group",
    "gruppe_verlassen": "Leave Group",
    "gruppen_chats": "Group Chats",
    "heller_modus": " Light Mode",
    "how_to_receive_drops": "How do I receive drops?",
    "identitaets_assistent": "Identity Wizard",
    "inactivity_lock_duration": "Lock when inactive",
    "inactivity_lock_duration_desc": "After this period of no input, GaiaCOM will automatically be cryptographically locked.",
    "inactivity_lock_notice": "GaiaCOM has been cryptographically blocked due to inactivity.",
    "include_plaintext": "Include plain text",
    "invite_code_label": "Invitation code",
    "join_group_title": "Join group",
    "kanaele": "Channels",
    "kanal_erstellen": "+ Channel",
    "kein_chat_ausgewaehlt": "No chat selected",
    "kein_kanal_ausgewaehlt": "No channel selected",
    "keine_gruppe_ausgewaehlt": "No group selected",
    "keine_mails": "No mails available.",
    "key_change_warn_desc": "This contact's public key has changed. Check the fingerprint before trusting it.",
    "key_change_warn_title": "Cryptographic warning",
    "key_change_warning_changed": "has changed. This may be a sign of a man-in-the-middle attack!",
    "key_change_warning_msg": "The identity key for contact",
    "key_transparency": "Key Transparency (Key History)",
    "kopiert": "Copied",
    "kryptographische_schluessel": "Cryptographic Keys",
    "kryptographische_schluessel_desc": "Show private keys and backup seed phrase.",
    "laden": "Loading...",
    "leeren": "Empty",
    "loading": "Load...",
    "local_key_vault": "Local key vault",
    "local_keys_label": "Local keys",
    "lock_on_reload": "Always lock after reload",
    "logout": "Log Out",
    "mail_compose": "Compose mail",
    "mein_profil": "My Profile",
    "melden": "Report",
    "menu": "Menu",
    "message": "News",
    "message_id": "Message ID",
    "message_pin": "Pin",
    "message_pinned_title": "Pinned messages",
    "message_react": "React",
    "message_reply": "Answer",
    "message_replying_to": "Answer to",
    "message_save": "Save",
    "message_saved": "Saved",
    "message_to_channel": "Message to",
    "message_unpin": "Solve",
    "message_unsave": "Don't save",
    "mitglied": "Member",
    "mitglieder": "Members",
    "ml_kem": "ML-KEM",
    "neue_mail": "New email",
    "never_auto_lock": "Never automatically",
    "new_fingerprint": "New fingerprint",
    "new_identity": "New Identity",
    "new_password": "New Password",
    "no_description": "No description",
    "no_key_history": "No key history recorded.",
    "no_specification": "No specification",
    "old_fingerprint": "Old fingerprint",
    "open_privacy_imprint": "Open imprint and data protection",
    "post_quantum_e2e": "Post-Quantum E2E",
    "posteingang": "Inbox",
    "powered_by": "Powered by",
    "privacy_imprint_menu_desc": "Show GDPR, data protection and legal notice.",
    "privacy_imprint_profile_desc": "GaiaCOM processes communication content according to the principles of data minimization, end-to-end encryption and local key control.",
    "privacy_imprint_title": "Data protection & legal notice",
    "profil": "Profile",
    "profile_details": "Profile Details",
    "profile_settings_hint": "Profile settings are displayed in the right panel.",
    "profile_unlock_desc": "For security reasons, you must enter your password again to view your private cryptographic keys.",
    "proof_hash": "Proof Hash:",
    "public_drop_desc": "Secure Drop for external text-only reports without a GaiaCOM account.",
    "public_drop_message": "Message",
    "public_drop_message_placeholder": "Enter confidential text...",
    "public_drop_send": "Send GaiaDrop",
    "public_drop_sender": "Optional sender note",
    "public_drop_sender_placeholder": "Name, case ID, or anonymous",
    "public_drop_target": "Target GaiaID",
    "quanten_chat": "Quantum Chat",
    "quantum_secure_exchange": "Quantum-secure exchange via...",
    "quantum_secure_net": "GaiaCOM Quantum-Secure Network (Ed25519 & ML-KEM)",
    "quantum_shield_desc": "The GaiaCOM network protects your privacy with a multi-layered, hybrid encryption protocol secure against attacks from future quantum computers.",
    "quantum_shield_l1_desc": "Uses the FIPS 203 standard to encapsulate a symmetric shared key. Prevents passive eavesdropping and later decryption (\\\\\\",
    "quantum_shield_l1_title": "1. Post-Quantum Protection (ML-KEM-1024)",
    "quantum_shield_l2_desc": "A classical, ultra-fast Diffie-Hellman key exchange method serving as an additional security layer in the hybrid scheme.",
    "quantum_shield_l2_title": "2. Elliptic-Curve Cryptography (X25519)",
    "quantum_shield_l3_desc": "Every message and federation envelope is cryptographically signed to verify sender authenticity beyond doubt.",
    "quantum_shield_l3_title": "3. Digital Signatures (Ed25519)",
    "quantum_shield_l4_desc": "Encrypts message content symmetrically and binds sender, recipient, and metadata tightly into the Authenticated Additional Data (AAD) to prevent replay attacks.",
    "quantum_shield_l4_title": "4. AAD Authentication (AES-256-GCM)",
    "quantum_shield_status": " Quantum Shield Status",
    "receive_drops_step1": "Share your GaiaID (e.g. via the copy button above) with external sources.",
    "receive_drops_step2": "They open the login page of your GaiaCOM instance, switch to the tab",
    "receive_drops_step3": "and send their encrypted message to your address there.",
    "receiver_gaia": "GaiaCOM receiver",
    "receiver_smtp": "SMTP recipient",
    "records_stored": "Records saved",
    "refresh": "Update",
    "report_abuse_desc": "Do you want to report this message and submit cryptographic evidence of abuse to the server?",
    "report_abuse_title": "Report abuse",
    "reputation_status": "Reputation Status",
    "room_chat_start_hint": "Start the conversation! All messages in this group channel are decentralized, quantum-secure E2E encrypted.",
    "room_policy_audit": "Audit trail and key rotation active.",
    "room_policy_crisis": "Crisis room",
    "room_policy_e2ee": "Zero-knowledge space. E2EE quantum safe.",
    "room_policy_title": "Room guidelines",
    "room_policy_zero_knowledge": "Policy",
    "room_security_note_desc": "All key changes are validated via Key Transparency. Use GaiaVault for private backup logs.",
    "room_security_note_title": "Pinned security note",
    "save_profile": "Save Profile",
    "schluessel_entsperrt": "🔑 Lock keys again",
    "search_gaia_label": "Find Gaia address",
    "security_warning_title": "Security warning",
    "select_channel_chat": "Select a channel from the left sidebar to start chatting.",
    "select_contact_chat": "Select a contact from the left panel to start a quantum-secure E2E chat.",
    "select_mail_read": "Select a mail from the list to read its quantum-secure contents, or create a new message.",
    "senden": "Send",
    "sender_signature": "Sender Signature",
    "server_log": "Server Log:",
    "server_received": "Server Received",
    "session_lock": "Session lock",
    "setup_address_keys": "Create address and keys",
    "setup_profile": "Setup in Profile",
    "smtp_inbox_title": "SMTP Inbox",
    "smtp_legacy_badge": "Legacy SMTP / Unsafe",
    "smtp_mode_option": "Legacy SMTP bridge",
    "smtp_security_warning": "This mail was transmitted via the classical, unencrypted SMTP protocol. No End-to-End encryption active.",
    "smtp_security_warning_desc": "This message is leaving the GaiaCom security room. SMTP delivery does not provide GaiaCom native end-to-end guarantee, no TrustMesh guarantee and no Godmode guarantee from the gateway.",
    "spam_verdacht": "Spam/Suspected",
    "spam_warning_desc": "This message has suspicious reputation signals.",
    "spam_warning_title": "Spam warning",
    "speichern": "Save",
    "sperren": "Lock",
    "standard_group_status": "Standard group chat (E2EE encrypted)",
    "status": "status",
    "subject": "Regarding",
    "suchen": "Search Gaia address...",
    "tage": "Days",
    "time_unknown": "Time unknown",
    "transmission_mode": "Transfer mode",
    "trust_age": "Trust Age",
    "trust_passport_title": "Trust Passport",
    "unbestaetigt": "Unconfirmed",
    "unknown_sender": "Unknown",
    "unlock_btn": "Unlock",
    "unlock_btn_profile": "Unlock",
    "unlock_desc": "Your private key file is stored encrypted. Enter your password to load the cryptographic keys only in RAM.",
    "unlock_logout": "Log out and close local keys",
    "unlock_title": "Unlock Identity",
    "untrusted": "Untrusted",
    "update_password": "Update Password",
    "upload_avatar_btn": "Upload Image (Sanitized)",
    "vault_btn_encrypt": "Encrypt Record",
    "vault_btn_lock": "Lock Vault",
    "vault_btn_unlock": "Unlock Vault",
    "vault_copied_success": "Copied to clipboard",
    "vault_decrypted_content": "Decrypted content",
    "vault_desc": "Local encrypted vault for recovery backups, identity notes, server credentials, emergency contacts, legal notes, security events, and private logs.",
    "vault_empty": "No secure records stored yet.",
    "vault_locked_pane_notice": "Vault is locked. Please unlock on the right.",
    "vault_new_record": "New secure record",
    "vault_pwd_placeholder": "Enter Vault password...",
    "vault_record_body": "Record content",
    "vault_record_body_placeholder": "Enter encrypted record content...",
    "vault_record_category": "category",
    "vault_record_title": "Record title",
    "vault_record_title_placeholder": "Title of Secure Record",
    "vault_title": "GaiaVault Secure Records",
    "verify_new_fingerprint_hint": "Check the new fingerprint before accepting the key.",
    "vertrauenswuerdig": "Trustworthy",
    "vision_gaia_technology": "VisionGaiaTechnology",
    "von": "From",
    "warnung": "Warning",
    "wizard_address": "Address",
    "wizard_back": "Back",
    "wizard_check1": "I have securely stored my seed.",
    "wizard_custom_domain": "Use custom domain",
    "wizard_desc1": "GaiaCOM does not store private keys server-side. Without the Mnemonic Seed, no one can recover lost messages.",
    "wizard_desc2": "Your address determines the federated node through which encrypted envelopes are routed.",
    "wizard_fallback": "Fallback Nodes",
    "wizard_finish": "Finish Setup",
    "wizard_next": "Next",
    "wizard_server_domain": "Server node domain",
    "wizard_step1": "1. Backup Seed",
    "wizard_step2": "2. Address & Server",
    "wizard_title1": "Secure Recovery Keys",
    "wizard_title2": "Select GaiaCOM Address",
    "write_message_placeholder": "Write a secure message...",
    "you": "You",
    "zero_knowledge": "Zero Knowledge",
    "zero_knowledge_encryption": "Zero-Knowledge Encryption",
    "Chat fuer alle geleert": "The chat has been emptied for all participants.",
    "Chat geleert": "The chat has been cleared for your local inbox.",
    "Nachricht fuer alle geloescht": "The message has been deleted for all participants.",
    "Nachricht geloescht": "The chat message has been removed locally from your inbox.",
    "anpinnen": "Pin",
    "chat_loeschen": "Delete chat",
    "confirm_delete_chat_desc": "Are you sure you want to delete and hide the chat?",
    "confirm_leave_group_desc": "Do you really want to leave this group?",
    "entpinnen": "Unpin",
    "group_deleted": "Group deleted successfully.",
    "group_left": "Leave the group successfully.",
    "gruppe_loeschen": "Delete group",
    "loeschen": "Delete",
    "no_active_chats": "No active chats. Search for contacts above to start a chat.",
    "pinned": "Pinned",
    "wizard_check_credentials": "I am responsible for keeping my access data safe.",
    "wizard_check_is_beta": "I understand that GaiaCom is beta software.",
    "wizard_check_no_illegal": "I will not use GaiaCom for unlawful purposes.",
    "wizard_check_no_uptime": "I understand that there is no guarantee of availability.",
    "wizard_check_smtp_security": "I understand that SMTP messages do not provide full GaiaCom security.",
    "wizard_check_terms_read": "I have read the Beta Terms of Service.",
    "wizard_step_terms": "Terms of Use",
    "wizard_terms_text": "GaiaCom Terms of Use and Beta Testing Agreement (Beta Phase)\n\nProvider: VisionGaiaTechnology (hereinafter referred to as “Provider”)\nStatus: Public beta testing phase\nValidity: From June 21, 2026\n\n⚠️ THE MOST IMPORTANT NOTE IN ADVANCE (PLEASE READ CAREFULLY)\nGaiaCom is in a public beta testing phase. Despite extensive security measures, the freedom from errors, continuous availability or absolute security of the software and the underlying infrastructure cannot be guaranteed. Use at your own risk. Users are responsible for the safe storage of their access data (especially keys for GaiaVault) and for compliance with applicable laws.\n\n1. Subject and purpose of the beta test phase\n1.1. Purpose of provision: GaiaCom is a novel email and chat service based on post-quantum cryptography (PQC). The provision during the beta phase is intended exclusively for technical testing, load simulation, finding program errors (bugs) and optimizing user-friendliness.\n1.2. Beta status: The user is aware that the software offered is a preliminary version (beta software). This is not yet fully developed technically, does not meet the standard of a final, commercial product and can cause errors, data loss, transmission delays or system crashes.\n1.3. No right to continuation: The provider is entitled at any time to discontinue the service in whole or in part, to change or restrict functions or to remove them temporarily or permanently without giving reasons.\n\n2. Availability and Disclaimer of Warranty\n2.1. No availability guarantee: GaiaCom is provided without any guarantee of availability or uptime. There is no right to uninterrupted availability of the service.\n2.2. Exclusion of warranty: The software is provided in its current state (“as is”) and subject to availability. To the extent permitted by law, any warranty claims for material and legal defects in the software are excluded. In particular, there is no guarantee that the software is error-free, free of malware or suitable for a particular purpose.\n\n3. Risk management and user obligations\n3.1. Prohibition of storage of critical data: The user undertakes not to exclusively store or transmit via GaiaCom any business-critical, vital, operationally necessary or legally particularly sensitive data (such as patient files, highly sensitive financial data or officially regulated secrets). The service may not be used for infrastructure where unforeseen failures could result in personal injury, property damage or significant financial loss.\n3.2. Self-responsible backup: The user is responsible for backing up all data received or sent via GaiaCom that he needs in the long term on his own, independent systems (backup copies). The provider does not guarantee the permanent storage or restoreability of data on its servers.\n\n4. Cryptographic features and GaiaVault\n4.1. Post-quantum cryptography (PQC): GaiaCom implements state-of-the-art, future-oriented encryption processes that are designed to withstand attacks from future quantum computers. However, the user is aware that this is a dynamic and new scientific field. Absolute, irrefutable security cannot be guaranteed based on the current state of science and technology. Terms such as “100% secure”, “uncrackable” or “military secure” are expressly not guaranteed.\n4.2. No recovery guarantee (GaiaVault): GaiaCom relies on a consistent zero-knowledge security concept. The encryption wedges and access data remain solely in the control of the user (secured via GaiaVault).\nIMPORTANT: If the user loses their passwords, passphrases, private keys or recovery seeds, the provider has no technical ability to reconstruct or reset this data. Loss of these access data inevitably leads to the irrevocable loss of access to the user account and all data encrypted therein.\n4.3. Not yet fully audited: The software is continuously subjected to internal security checks, but at the time of this beta phase it has not yet undergone a final, comprehensive external security audit by independent testing bodies.\n\n5. Interfaces, legacy protocols and federation\n5.1. SMTP Bridge Note: GaiaCom offers the ability to communicate via classic email protocols (such as SMTP). The user is aware that messages that leave the native GaiaCom security area (e.g. when sent to a conventional @gmail.com or @gmx.de address) are transported via unencrypted or third-party servers. GaiaCom's end-to-end security guarantees apply only to a limited extent or not at all to such outgoing or externally incoming legacy messages.\n5.2. Federation Note: If GaiaCom operates on a federated network, messages and data may pass through third-party servers. While the contents of the messages remain protected by end-to-end encryption, metadata (such as time of sending, IP addresses of the servers involved and recipient addresses) may be technically visible to the operators of these federated servers. The provider has no influence on the data protection practices of third-party server operators in the federated network.\n\n6. Acceptable Uses and Prohibited Activities\nThe user undertakes not to use the service improperly or for illegal purposes. In particular, the following are prohibited:\n- Distributing, sending or hosting viruses, malware, phishing content or other malicious software.\n- Using the Service to conduct denial-of-service attacks (DDoS) or unsolicited bulk mailing (spam).\n- Abusing the system to commit fraud.\n- The distribution or exchange of illegal content, in particular depictions of child sexual abuse (CSAM), terrorist propaganda, calls for violence or other criminally relevant content.\n\n7. Abuse reporting system\n7.1. Reporting abusive behavior: Users have the opportunity to report abusive communications or illegal activities via the integrated abuse system.\n7.2. Processing of reports: In order to ensure protection against misuse, incoming reports can be technically analyzed (while maintaining privacy and encryption limits). This can lead to temporary or permanent suspension of user accounts or IP addresses in the event of proven violations of these terms of use.\n\n8. Limitation of Liability\n8.1. Standard of liability: The beta software is provided free of charge. According to the legal rules for donations or loans, the provider is therefore only liable for intent (intentional damage) and gross negligence.\n8.2. Exclusion of liability for data loss: Liability for the loss of data is excluded unless the loss was caused intentionally or through gross negligence by the provider and the user has fulfilled his obligation to mitigate damage through regular backups (outside GaiaCom).\n8.3. Legal limits: The above liability limitations do not apply to injury to life, body or health or to liability under the Product Liability Act.\n\n9. Open Source\nCertain GaiaCom components, libraries or client applications may be licensed under open source licenses (e.g. GPL, MIT, Apache). The respective license terms of these components remain unaffected by these terms of use and can be viewed in the corresponding source code repositories.\n\n10. Export Control and Compliance\nThe user is aware that cryptographic software may be subject to strict export controls and legal restrictions. The user is responsible for ensuring that the use of GaiaCom does not violate the laws, import/export restrictions or cryptography regulations of their respective country of residence.\n\n11. Data protection notice (short version for the beta)\n11.1. Minimal data collection: As part of the beta phase, the provider only collects data that is absolutely necessary for technical operation, troubleshooting and further development (e.g. server log files for error diagnosis).\n11.2. No insight into the content: Thanks to the consistent zero-knowledge and E2E encryption, the provider never has access to the contents of your chats, emails or keys stored in the GaiaVault.\n11.3. Detailed data protection declaration: The detailed data protection regulations are linked separately and must also be taken into account by the user before registering.\n\n12. Final provisions\n12.1. Applicable law: The law of the Federal Republic of Germany applies, excluding the UN Convention on Contracts for the International Sale of Goods.\n12.2. Subject to change: Since GaiaCom is in active development, the provider reserves the right to adapt these conditions at any time with effect for the future. The current version is available in the application.",
    "wizard_terms_title": "GaiaCom Terms of Use and Beta Testing Agreement (Beta Phase)",
    "node_operator": "Node operator",
    "search_channels": "Search channels...",
    "senior_reviewer": "Senior Reviewer",
    "trusted_reviewer": "Trusted Reviewer",
    "active_frequencies": "Active frequencies",
    "connected_rooms": "CONNECTED SPACES",
    "dashboard": "Dashboard",
    "empty_chats": "No active chats available.",
    "empty_messages": "No new messages available.",
    "encrypted": "Encrypted",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "Install app",
    "install_app_desc": "For quick start & offline mode",
    "kommandozentrale_alpha": "ALPHA command center",
    "network_online": "NETWORK: ONLINE",
    "new_room": "New space",
    "no_frequencies_active": "No frequencies active. Create a new room to start communication.",
    "no_id": "No ID",
    "open_chats": "Open chats",
    "open_inbox": "Open inbox",
    "primary_identity": "PRIMARY IDENTITY",
    "recent_chats": "New chats",
    "recent_messages": "Latest news",
    "session_encrypted": "Session encrypted: {name}",
    "session_secure": "STATUS: SECURE",
    "system_verlassen": "Exit system",
    "write_message": "Write a message",
    "onboarding_step_profile": "Profile",
    "onboarding_step_security": "Protection",
    "onboarding_step_backup": "Backup",
    "onboarding_step_launch": "Start",
    "onboarding_loading_gaia_id": "Loading Gaia-ID",
    "onboarding_setup_kicker": "GaiaCom Initial Setup",
    "onboarding_profile_title": "Make GaiaCom your space.",
    "onboarding_profile_desc": "Your display name and avatar remain locally controlled and can be changed in your profile at any time.",
    "onboarding_security_title": "What GaiaCom is protecting for you right now.",
    "onboarding_security_desc": "GaiaCom separates identity, keys, messages, and network status. You only see the short user version here.",
    "onboarding_backup_title": "A backup is your real emergency exit.",
    "onboarding_backup_desc": "Without recovery data, no one can rescue your identity. That is exactly the point of real end-to-end security.",
    "onboarding_launch_title": "Ready. What do you want to do first?",
    "onboarding_launch_desc": "You can start right away or end the tour and continue working in the dashboard.",
    "onboarding_display_name": "Display Name",
    "onboarding_display_name_placeholder": "How should GaiaCom display you?",
    "onboarding_select_avatar": "Select Avatar",
    "onboarding_sec_identity_title": "Identity",
    "onboarding_sec_identity_desc": "Your Gaia-ID is your network anchor. Contacts can detect key changes.",
    "onboarding_sec_messages_title": "Messages",
    "onboarding_sec_messages_desc": "Content is decrypted locally. Edited messages receive new signatures.",
    "onboarding_sec_network_title": "Network",
    "onboarding_sec_network_desc": "Security Center and Abuse Center make risks visible without a global backdoor.",
    "onboarding_sec_transparency_title": "Transparency",
    "onboarding_sec_transparency_desc": "Writes security-relevant events to the log so that warnings remain traceable.",
    "onboarding_backup_notice_title": "Important for regular users",
    "onboarding_backup_notice_desc": "Save your recovery data separately from this device. If you lose your password and backup, GaiaCom remains locked on purpose.",
    "onboarding_backup_consent": "I know that my backup is crucial for recovery and device changes.",
    "onboarding_inbox_title": "Inbox",
    "onboarding_inbox_desc": "Read emails and compose your first message.",
    "onboarding_contacts_title": "Contacts",
    "onboarding_contacts_desc": "Check your first contact or start a chat.",
    "onboarding_channels_title": "Channels",
    "onboarding_channels_desc": "Discover public frequencies.",
    "onboarding_security_title_card": "Security Center",
    "onboarding_security_desc_card": "View GaiaShield status.",
    "onboarding_later": "Later",
    "onboarding_back": "Back",
    "onboarding_continue": "Continue",
    "onboarding_complete_setup": "Complete Setup",
    "auth_legal_consent": "I have read and agree to the privacy policy and terms of use.",
    "auth_show_terms": "Show terms of use",
    "auth_recovery_mode": "Recovery Mode",
    "auth_recovery_import_title": "Import Recovery File",
    "auth_recovery_import_desc": "Restore your GaiaCom keys from a password-protected backup file. Afterwards, mnemonic and username are pre-filled.",
    "auth_recovery_file_pwd_placeholder": "Recovery file password",
    "auth_recovery_local_pwd_placeholder": "New local unlock password min. 12 characters",
    "auth_recovery_importing": "Importing...",
    "auth_recovery_decrypt": "Decrypt Recovery",
    "auth_back_to_login": "Back to login",
    "auth_terms_title": "GaiaCom Beta Terms of Use",
    "auth_terms_close": "Close",
    "auth_cookie_title": "GaiaCOM remains sovereign.",
    "auth_cookie_desc": "We only use technically necessary local storage for language, session, and security. No tracking, no advertising cookies, no third-party profiles.",
    "auth_cookie_accept": "Understood",
    "sc_explainer_title": "What is actually protected here?",
    "sc_explainer_desc": "GaiaShield is the protective layer between your account, your messages, and the network. It does not decide on content, but on technical risks: manipulation, replay attempts, unauthorized access, conspicuous login patterns, and insecure gateway transitions.",
    "sc_explainer_identity_desc": "Checks login anomalies, session risks, and access to other identities.",
    "sc_explainer_messages_desc": "Detects replay patterns, manipulated envelopes, and missing integrity features.",
    "sc_explainer_network_desc": "Flags federation, rate limit, and SMTP risks before trust is incorrectly displayed.",
    "sc_open_security_warnings": "Open Security Warnings",
    "sc_opt_all": "All",
    "sc_opt_low": "Low",
    "sc_opt_medium": "Medium",
    "sc_opt_high": "High",
    "sc_opt_critical": "Critical",
    "sc_opt_failed_login": "Failed Login",
    "sc_opt_auth_attack": "Auth Attack",
    "sc_opt_rate_limit": "Rate Limit",
    "sc_opt_policy_violation": "Policy Violation",
    "sc_opt_message_replay": "Message Replay",
    "sc_node_security_data_unavailable": "Node security data unavailable",
    "sc_total_events": "Total Events",
    "sc_login_attacks": "Login Attacks",
    "sc_rate_limits_active": "Active Rate Limits",
    "sc_smtp_shield_hits": "SMTP Shield Hits",
    "sc_top_event_categories": "Top Event Categories",
    "sc_no_entries": "No entries.",
    "sc_node_audit_log": "Node Audit Log (Recent Events)",
    "sc_no_node_events": "No node events.",
    "archiv": "Archive",
    "entwuerfe": "Drafts",
    "markiert": "Starred",
    "wichtig": "Important",
    "snoozed": "Snoozed",
    "papierkorb": "Trash",
    "spam": "Spam",
    "cancel": "Cancel",
    "error": "Error",
    "success": "Success",
    "kopieren": "Copy",
    "block_contact": "Block Contact",
    "unblock_contact": "Unblock Contact",
    "report_contact": "Report Contact",
    "check_fingerprint": "Verify Fingerprint",
    "export_encrypted": "Export (Encrypted)",
    "export_gaiaproof": "Export (GaiaProof)",
    "export_password_prompt": "Please enter a password to encrypt the chat export:",
    "export_success": "Chat exported and encrypted successfully.",
    "export_failed": "Export failed: ",
    "gaiaproof_export_success": "GaiaProof package exported successfully.",
    "gaiaproof_export_failed": "GaiaProof export failed: ",
    "export_gaiaproof_confirm": "Do you want to download the GaiaProof package with all signatures and server delivery receipts? This may take a moment.",
    "group_settings_is_private": "Private Room (not publicly searchable, join requests only)",
    "group_settings_read_only": "Read-only mode (only owner and admins can send messages)",
    "group_settings_slow_mode": "Slow Mode (send cooldown)",
    "gsn_title": "GSN Social Feed",
    "gsn_node_feed": "Node Feed",
    "gsn_following_feed": "Following",
    "gsn_feed_empty": "No posts found.",
    "gsn_composer_placeholder": "What's new in the federation?",
    "gsn_post_btn": "Share",
    "gsn_profile": "User Profile",
    "gsn_followers": "Followers",
    "gsn_following": "Following",
    "gsn_bio": "Description / Bio:",
    "gsn_bio_label": "Description / Bio",
    "gsn_display_name": "Display Name",
    "gsn_edit_profile": "Edit Profile",
    "gsn_save_profile": "Save",
    "gsn_add_image": "Add Image (Encrypted)",
    "gsn_add_emoji": "Insert Emoji",
    "gsn_avatar_emoji": "Avatar (Emoji)",
    "gsn_follow": "Follow",
    "gsn_unfollow": "Unfollow",
    "gsn_repost": "Share / Repost",
    "gsn_post_created": "Post shared successfully.",
    "gsn_image_uploaded": "Image encrypted and uploaded.",
    "gsn_upload_failed": "Image upload failed: ",
    "gsn_comment_placeholder": "Write a comment...",
    "gsn_delete_confirm_title": "Delete post?",
    "gsn_delete_confirm_desc": "Are you sure you want to permanently delete this post?",
    "gsn_delete_comment_confirm_title": "Delete comment?",
    "gsn_delete_comment_confirm_desc": "Are you sure you want to permanently delete this comment?",
    "gsn_report": "Report",
    "gsn_report_title": "Report violation",
    "gsn_report_category": "Category",
    "gsn_report_spam": "Spam / Advertisement",
    "gsn_report_harassment": "Harassment / Hate Speech",
    "gsn_report_abuse": "Abuse",
    "gsn_report_illegal": "Illegal Content",
    "gsn_report_severity": "Severity",
    "gsn_report_low": "Low",
    "gsn_report_medium": "Medium",
    "gsn_report_high": "High",
    "gsn_report_comment": "Additional Comment",
    "gsn_report_submit": "Report",
    "gsn_report_submitted": "Report submitted to Governance.",
    "gsn_report_post": "Report post",
    "report_group": "Report group",
    "report_group_reason_prompt": "Please enter a reason for reporting (optional):",
    "report_reason_prompt": "Please enter a reason for reporting (optional):",
    "report_failed": "Reporting failed: ",
    "report_success": "Contact reported successfully.",
    "room_read_only_placeholder": "Only owner and admins can write",
    "read_only_active": "Read-only mode",
    "slow_mode_active": "Slow Mode active",
    "kommandozentrale": "Command Center",
    "kontakt_blockiert": "Contact blocked",
    "kontakt_freigegeben": "Contact unblocked",
    "mailbox_settings_title": "Mailbox Settings",
    "mailbox_settings_desc": "Manage signature, language, mail filters.",
    "mic_access_denied": "Microphone access denied: ",
    "no_frequencies_active_desc": "Create a new room to start communicating.",
    "key_changed_warning_title": "SECURITY NOTICE:",
    "key_changed_warning_desc": "The identity key of this sender has been updated or differs from the previously known key. Please verify the fingerprint via another secure channel.",
    "sc_col_category": "Category",
    "search_members": "Search members...",
    "tab_general": "General",
    "tab_members": "Members",
    "tab_requests": "Requests",
    "tab_invites": "Invites",
    "tab_logs": "Logs",
    "auth_why_gaiacom": "Why GaiaCOM?",
    "auth_why_gaiacom_desc": "The secure, decentralized alternative for your confidential communication.",
    "auth_self_managed_id": "Self-managed ID",
    "auth_self_managed_id_desc": "Instantly create secure cryptographic identities without providing an email address or phone number.",
    "auth_gaiadrop_secure_exchange": "Secure exchange without account",
    "auth_gaiadrop_benefit_e2ee": "End-to-end encrypted",
    "auth_gaiadrop_benefit_no_login": "No login required",
    "auth_gaiadrop_benefit_inbox": "Direct delivery to the recipient's inbox",
    "auth_terms_of_use": "Terms of Use",
    "auth_terms_of_use_show": "Show Terms of Use",
    "auth_consent_privacy_terms": "I have read and agree to the privacy policy and terms of use.",
    "auth_recovery_import_file": "Import Recovery File",
    "auth_recovery_password": "Recovery File Password",
    "auth_recovery_local_password": "New local unlock password min. 12 characters",
    "auth_recovery_decrypting": "Decrypting Recovery...",
    "auth_recovery_back": "Back to login",
    "auth_cookie_sovereign": "GaiaCOM remains sovereign.",
    "auth_cookie_sovereign_desc": "We only use technically necessary local storage features for language, session and security. No tracking, no advertising cookies, no third-party profiles.",
    "auth_cookie_sovereign_accept": "Got it",
    "unlock_keyboard_toggle": "⌨️ Use Keyboard",
    "unlock_keypad_toggle": "🔢 Use PIN-Pad",
    "unlock_status_denied": "ACCESS DENIED / RETRY",
    "unlock_status_decrypting": "DECRYPTING VAULT...",
    "unlock_status_secured": "VAULT SECURED / LOCKED",
    "auth_landing_nav_legal": "Legal",
    "auth_landing_nav_beta": "Beta Test",
    "auth_landing_card1_title": "Post-Quantum Cryptography (ML-KEM)",
    "auth_landing_card2_title": "100% Federated",
    "auth_landing_card3_title": "Zero-Knowledge",
    "auth_landing_card4_title": "Metadata Protection",
    "auth_landing_card5_title": "Self-Managed ID",
    "auth_landing_hybrid_title": "Today's cryptography plus protection against tomorrow.",
    "auth_landing_hybrid_desc": "GaiaCom combines proven classical key exchange with post-quantum key encapsulation. No blind choices — but defense in depth.",
    "auth_landing_x25519_desc": "Proven, fast elliptic curve key exchange for current devices and secure sessions.",
    "auth_landing_mlkem_desc": "Post-Quantum key encapsulation for long-term confidentiality against harvest-now-decrypt-later scenarios.",
    "auth_landing_cycle_title": "The server sees nothing. The network only carries noise.",
    "auth_landing_step1_title": "Local Encryption",
    "auth_landing_step1_desc": "The message is encrypted on the sender's device — before it ever reaches the network or server.",
    "auth_landing_step2_title": "Transport as Blob",
    "auth_landing_step2_desc": "The package travels as cryptographic noise through federated nodes or decentralized storage layers.",
    "auth_landing_step3_title": "Federated Storage",
    "auth_landing_step3_desc": "No central mailbox as a honey pot. Data is fragmented, federated, or decentralized and fully encrypted.",
    "auth_landing_step4_title": "Local Decryption",
    "auth_landing_step4_desc": "Only the recipient's private key can turn the blob back into readable content.",
    "auth_landing_trinity_title": "One protocol concept. Three infrastructure levels.",
    "auth_landing_enterprise_desc": "For corporations, law firms, medium enterprises, industry, and private banking. Closed communication circles with administrative control, compliance, and support.",
    "auth_landing_enterprise_list1": "Internal sovereignty and user administration",
    "auth_landing_enterprise_list2": "Self-hosted node or managed sovereign cluster",
    "auth_landing_enterprise_list3": "SLA, support, and premium modules",
    "auth_landing_network_desc": "The open network for digital privacy. No platform for data commerce, but infrastructure for free and encrypted communication.",
    "auth_landing_network_list1": "Open source client",
    "auth_landing_network_list2": "Federated nodes",
    "auth_landing_network_list3": "No central decryption keys",
    "auth_landing_defend_desc": "Specialized high-security infrastructure for authorities, critical infrastructure, and isolated communication silos.",
    "auth_landing_defend_list1": "Air-gapped and isolated deployments",
    "auth_landing_defend_list2": "White labeling and source code audit",
    "auth_landing_defend_list3": "National digital sovereignty",
    "auth_landing_gov_title": "Open protocol. Commercial execution. Clear legal separation.",
    "auth_landing_gov_desc": "GaiaCom separates the open protocol, open clients, and commercial premium infrastructure. Trust comes from transparency — revenue from enterprise operations, support, integrations, and specialized modules.",
    "auth_landing_price1_desc": "Bot protection fee for AppStore/PlayStore distribution.",
    "auth_landing_price2_desc": "Open Source for users who prefer to compile it themselves.",
    "auth_landing_price3_desc": "For medium-sized businesses, law firms, and sensitive teams.",
    "auth_landing_price4_desc": "For corporations, HA clusters, LDAP, and administrative root access.",
    "auth_landing_license1_desc": "Maximum transparency for users, forks, and community audits.",
    "auth_landing_license2_desc": "Copyleft protection against cloud theft and closed protocol forks.",
    "auth_landing_license3_desc": "LDAP, root access, audit, SLA, and specialized business logic.",
    "auth_landing_final_title": "Communication according to the trust model.",
    "auth_landing_final_desc": "GaiaCom does not simply replace email. GaiaCom raises the question of why confidential communication in the year of post-quantum migration is still based on central mailboxes, readable servers, and 40-year-old assumptions.",
    "auth_landing_final_note": "Note: This landing page describes an architectural vision and product roadmap. Security promises must be confirmed by implementation, audits, and real-world tests prior to productive deployment."




  };

export default en;